var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PieChart"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 230",
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "url(#paint0_linear_3215_5276)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 231",
    d: "M36 15.1V1.80005C40.4912 1.80005 44.9384 2.68466 49.0878 4.40337C51.1481 5.25679 53.115 6.30756 54.962 7.53808M36 15.1L46.6967 4.40337M36 15.1V26.5M36 26.5V36H37.9M36 26.5L54.962 7.53808M54.962 7.53808C56.8347 8.78572 58.5842 10.2181 60.1831 11.817C63.3588 14.9928 65.878 18.7629 67.5967 22.9123C69.3154 27.0616 70.2 31.5088 70.2 36.0001H59.4M37.9 36L60.1831 13.717M37.9 36L48.6 36M48.6 36L64.8 19.8M48.6 36L59.4 36.0001M59.4 36.0001L68.4 27",
    stroke: "url(#paint1_linear_3215_5276)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3215_5276",
    x1: 0,
    y1: 36,
    x2: 72,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3215_5276",
    x1: 36,
    y1: 18.9,
    x2: 70.2,
    y2: 18.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.464704ae0b023154d7bddf93027fa131.svg";
export { ForwardRef as ReactComponent };